export const users = [
  {
    id: "0299233e-04b9-450c-a2da-3ec3cd5776f8",
    nickname: null,
    name: null,
    picture: "https://tinyfac.es/data/avatars/344CFC24-61FB-426C-B3D1-CAD5BCBD3209-500w.jpeg",
    birthday: null,
    first_name: null,
    last_name: null,
    gender: null,
    //email: "No email",
    phone: null,
    groups: [
      {
        id: 24,
        name: "default",
        is_default: true,
        is_deletable: false
      }
    ],
    registered: "2019-09-30T19:02:56+0300",
    external_id: null,
    last_login: "2019-09-30T21:53:34+0300",
    ban: null,
    country: null
  },
  {
    id: "cb1b982c-e10f-11e9-aa07-42010aa8002f",
    nickname: null,
    name: null,
    picture: "https://randomuser.me/api/portraits/med/men/64.jpg",
    birthday: null,
    first_name: null,
    last_name: null,
    gender: null,
    email: "emseviltwin@mail.ru",
    phone: null,
    groups: [
      {
        id: 24,
        name: "default",
        is_default: true,
        is_deletable: false
      }
    ],
    registered: "2019-09-27T13:15:55+0300",
    external_id: "demo_user_new_1",
    last_login: "2019-09-27T13:15:55+0300",
    ban: null,
    country: null
  },
  {
    id: "7c4afb8c-6327-11e8-aac4-42010a8a001c",
    nickname: null,
    name: null,
    picture: "https://storage.googleapis.com/xll-xsolla-login-avatars/7c4afb8c-6327-11e8-aac4-42010a8a001c-5d15a865d01e7.png",
    birthday: "1111-12-12",
    first_name: null,
    last_name: null,
    gender: "m",
    //email: "No email",
    phone: null,
    groups: [
      {
        id: 24,
        name: "default",
        is_default: true,
        is_deletable: false
      }
    ],
    registered: "2018-05-29T13:03:07+0300",
    external_id: null,
    last_login: "2019-09-25T08:49:37+0300",
    ban: null,
    country: null
  },
  {
    id: "a6aa9121-e695-40b3-b2c3-1c28d731052c",
    nickname: null,
    name: null,
    picture: null,
    birthday: null,
    first_name: null,
    last_name: null,
    gender: null,
    email: "cb62dd800b@hellomail.fun",
    phone: null,
    groups: [
      {
        id: 24,
        name: "default",
        is_default: true,
        is_deletable: false
      }
    ],
    registered: "2019-09-25T08:47:31+0300",
    external_id: null,
    last_login: "2019-09-25T08:48:28+0300",
    ban: null,
    country: null
  },
  {
    id: "762948f5-716c-46d0-883e-9e66887e55ed",
    nickname: null,
    name: null,
    picture: null,
    birthday: null,
    first_name: null,
    last_name: null,
    gender: null,
    email: "emseviltwin@mail.ru",
    phone: null,
    groups: [
      {
        id: 24,
        name: "default",
        is_default: true,
        is_deletable: false
      }
    ],
    registered: "2019-09-17T14:56:47+0300",
    external_id: null,
    last_login: "2019-09-17T20:16:12+0300",
    ban: null,
    country: null
  },
  {
    id: "9720d75e-d847-41c3-868b-8b18ee19ca0c",
    nickname: null,
    name: null,
    picture: null,
    birthday: null,
    first_name: null,
    last_name: null,
    gender: null,
    email: "xenkokk@gmail.com",
    phone: null,
    groups: [
      {
        id: 24,
        name: "default",
        is_default: true,
        is_deletable: false
      }
    ],
    registered: "2019-09-15T01:41:35+0300",
    external_id: null,
    last_login: "2019-09-15T01:41:35+0300",
    ban: null,
    country: null
  },
  {
    id: "08d8a852-da88-4533-b913-579a3abda10d",
    nickname: null,
    name: null,
    picture: null,
    birthday: null,
    first_name: null,
    last_name: null,
    gender: null,
    //email: "No email",
    phone: null,
    groups: [
      {
        id: 24,
        name: "default",
        is_default: true,
        is_deletable: false
      }
    ],
    registered: "2019-09-13T14:17:40+0300",
    external_id: null,
    last_login: "2019-09-13T14:17:40+0300",
    ban: null,
    country: null
  },
  {
    id: "d6d4a522-2414-409e-bc99-b26a0933749a",
    nickname: null,
    name: null,
    picture: null,
    birthday: null,
    first_name: null,
    last_name: null,
    gender: null,
    email: "mikoza@gmail.com",
    phone: null,
    groups: [
      {
        id: 24,
        name: "default",
        is_default: true,
        is_deletable: false
      }
    ],
    registered: "2019-08-28T01:36:54+0300",
    external_id: null,
    last_login: "2019-09-11T09:49:18+0300",
    ban: null,
    country: null
  },
  {
    id: "0c466a92-ecbe-48c4-9dd1-be30a76cf332",
    nickname: null,
    name: null,
    picture: null,
    birthday: null,
    first_name: null,
    last_name: null,
    gender: null,
    email: "plyusnina@live.ru",
    phone: null,
    groups: [
      {
        id: 24,
        name: "default",
        is_default: true,
        is_deletable: false
      }
    ],
    registered: "2019-09-11T09:47:53+0300",
    external_id: null,
    last_login: "2019-09-11T09:47:53+0300",
    ban: null,
    country: null
  },
  {
    id: "8998ed95-0d9e-43c5-b844-fc3bf79697f8",
    nickname: null,
    name: null,
    picture: null,
    birthday: null,
    first_name: null,
    last_name: null,
    gender: null,
    // email: "No email",
    phone: null,
    groups: [
      {
        id: 24,
        name: "default",
        is_default: true,
        is_deletable: false
      }
    ],
    registered: "2019-09-10T13:54:27+0300",
    external_id: null,
    last_login: "2019-09-10T13:54:27+0300",
    ban: null,
    country: null
  }
];
